import React, { Fragment, useContext, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { Route } from "react-router-dom";
import { Auth } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Navbar from "components/Navbar.js";
import EyepieceOne from "./EyepieceOne";
import EyepieceTwo from "./EyepieceTwo";
import EyepieceThree from "./EyepieceThree";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  image: {
    width: "100%",
    borderRadius: "50%",
  },
  text: {
    textAlign: "center",
  },
}));

function Home() {
  const classes = useStyles();
  const history = useHistory();
  // let { authState, user } = useContext(AuthContext);
  // console.log("HOME user", user);

  return (
    <Fragment>
      <Navbar />
      <Container className={classes.root} maxWidth="lg">
        <Route path="/eyepiece1">
          <EyepieceOne />
        </Route>
        <Route path="/eyepiece2">
          <EyepieceTwo />
        </Route>
        <Route path="/eyepiece3">
          <EyepieceThree />
        </Route>
        <Route exact path="/">
          <Typography variant="h2" gutterBottom>
            Building Microscopes for Reflection (BMR)
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={7}>
              <Typography variant="h5" gutterBottom>
                Eyepiece 1
              </Typography>

              <Typography variant="body1" gutterBottom>
                How are teachers using technology to support student learning?”
                NEED rest of writeup
              </Typography>
              <Typography variant="h5" gutterBottom>
                Eyepiece 2
              </Typography>

              <Typography variant="body1" gutterBottom>
                <strong>
                  “How do students experience and view learning from home?”
                </strong>{" "}
                In this data-collection and reflection activity, schools will
                select a sample of students (i.e. a classroom, a grade-level,
                or, even the entire school) to participate in a short, drawing
                activity depicting students home learning environment. Using
                rubrics to code and record different features in the student’s
                drawings, school leaders will be provided access to dynamic
                visualization dashboards summarizing their resulting data
                prompting empirical insights and refection of their students
                home learning experience.
              </Typography>
              <Typography variant="h5" gutterBottom>
                Eyepiece 3
              </Typography>

              <Typography variant="body1" gutterBottom>
                <strong>
                  This eyepiece examines the idea of narrative through the lens
                  of a storyteller.
                </strong>{" "}
                There are several components to great storytelling and we will
                examine a few such as, strategic narrative, institutional
                narrative and building a good story around your brand as an
                institution and/or district. You will also take into
                consideration the “why” of having a powerful story. Secondly,
                there will be a real-time exercise to visualize your school/
                district data in a creative way.
              </Typography>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box className={classes.videoContainer}>
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/etGHHyPYcbM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <br />
              <Typography variant="h5" gutterBottom>
                Team Members
              </Typography>
              <Grid container spacing={3}>
                <Grid item md={3} xs={12}>
                  <Link
                    href="http://reflectiveeducationalresearch.com/about.html"
                    variant="subtitle1"
                    target="_blank"
                  >
                    <Grid container>
                      <Grid item xs={12} className={classes.profile}>
                        <img
                          alt="Dr. Damian Bebell"
                          src="http://reflectiveeducationalresearch.com/media/bmr/damian.jpg"
                          className={classes.image}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.text}>
                        <Typography variant="button" gutterBottom>
                          Dr. Damian Bebell
                        </Typography>
                      </Grid>
                    </Grid>
                  </Link>
                </Grid>

                <Grid item md={3} xs={12}>
                  <Link
                    href="https://www.namwkim.org/"
                    variant="subtitle1"
                    target="_blank"
                  >
                    <Grid container>
                      <Grid item xs={12} className={classes.profile}>
                        <img
                          alt="Dr. Nam Wook Kim"
                          src="http://reflectiveeducationalresearch.com/media/bmr/nam.jpg"
                          className={classes.image}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.text}>
                        <Typography variant="button" gutterBottom>
                          Dr. Nam Wook Kim
                        </Typography>
                      </Grid>
                    </Grid>
                  </Link>
                </Grid>
                <Grid item md={3} xs={12}>
                  <Link
                    href="https://www.challengebasedlearning.org/project/cbl-full-sail-labs/"
                    variant="subtitle1"
                    target="_blank"
                  >
                    <Grid container>
                      <Grid item xs={12} className={classes.profile}>
                        <img
                          alt="Dr. Holly Ludgate"
                          src="http://reflectiveeducationalresearch.com/media/bmr/holly.jpg"
                          className={classes.image}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.text}>
                        <Typography variant="button" gutterBottom>
                          Dr. Holly Ludgate
                        </Typography>
                      </Grid>
                    </Grid>
                  </Link>
                </Grid>
                <Grid item md={3} xs={12}>
                  <Link
                    href="http://www.hippasus.com/"
                    variant="subtitle1"
                    target="_blank"
                  >
                    <Grid container>
                      <Grid item xs={12} className={classes.profile}>
                        <img
                          alt="Ruben R. Puentedura"
                          src="http://reflectiveeducationalresearch.com/media/bmr/ruben.jpg"
                          className={classes.image}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.text}>
                        <Typography variant="button" gutterBottom>
                          Dr. Ruben R. Puentedura
                        </Typography>
                      </Grid>
                    </Grid>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Route>
      </Container>
    </Fragment>
  );
}

export default Home;
